import NetworkErrorDetection from './NetworkErrorDetection'

export default NetworkErrorDetection
